// extracted by mini-css-extract-plugin
export default {"notes":"Notes_notes__2Vl5d","notes__value":"Notes_notes__value__pU-gZ"};